import { accountIdFormat } from "@redotech/redo-account-id";
import { MerchantConsolidationBinCriteriaSchema } from "@redotech/redo-return-warehouse-processing-common/merchant-consolidation-bin";
import { merchantConsolidationBinIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const ConsolidationBinSchema = z.object({
  criteria: MerchantConsolidationBinCriteriaSchema,
  id: merchantConsolidationBinIdFormat.schema,
  merchantAccountId: accountIdFormat.schema,
  merchantName: z.string(),
  name: z.string(),
});
